module.exports = __webpack_public_path__ + "img/browser-blue.8b3474b1.svg";